<template>
    <div>
        <menu-tile
            v-for="(item, i) in indexPageItems"
            v-bind:key="i"
            :menuItem="item"
            :focus="i === 0"
        ></menu-tile>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
//import brfssRouterLink from "@/components/sub/brfssRouterLink";
import menuTile from '@/components/sub/menuTile';
import current from '@/scripts/current';
import navMenuItems from '@/scripts/nav/menuItems';

export default {
    components: {
        //brfssRouterLink,
        menuTile
    },
    created: function () {
        const vm = this;
        vm.indexPageItems = navMenuItems.menuItems.indexPageItems;
    },
    data: function () {
        current.initializeAnalysis();
        return {
            indexPageItems: []
        };
    },
    methods: {
        // goToCrossTabulation: function () {
        //   this.$router.push({ path: "/crossTabulation/selectYear" });
        // },
        // goToLogisticRegression: function () {
        //   this.$router.push({ path: "/logisticRegression/selectYear" });
        // },
    }
};
</script>

<style scoped>
</style>
